module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"download":"Скачать QR-код","show":"Просмотреть","update":"Редактировать","delete":"Удалить","socialLink":"Ссылка для соцсетей","createQR":"Создать макет с QR-кодом"}}')
  delete Component.options._Ctor
}
